<template>
  <div>
    <header class="bar bar-nav" v-if="!isWapp">
      <a class="icon icon-left pull-left" @click="tolast"></a>
      <h1 class="title">我的对账单</h1>
    </header>

    <footer class="bar bar-footer-secondary"  style="color: white;height: 3.5rem;margin-bottom: -2rem;" v-if="asBillInfos && asBillInfos[0] && asBillInfos[0].summary" :style="{'height': emkt.leaveSpaceForFullScreen ? '5rem' : '3.5rem'}">
      <div style="text-align: center;color: red;font-size: .8rem;margin-top: .1rem">请您核对账单</div>
      <div>
        <div @click="submit()" style="width: 45%;float: left;border: 1px;text-align: center;"><span style="color:white;background-color: grey"><a class="button button-round" style="height: 1.5rem;  color: white;background-color: rgb(8, 148, 236);font-size: 18px" > 确认</a></span></div>
        <div style="width: 10%;float: left;border: 1px;text-align: center;margin-top: 10px"> </div>
        <div @click="senEmail()" style="width: 45%;float: left;border: 1px;text-align: center;"> <span style="background-color: #0894ec;" ><a class="button button-round" style="  height: 1.5rem;  color: white;background-color: rgb(8, 148, 236);font-size: 18px">有问题，请联系我</a></span></div>
      </div>
    </footer>

    <div class="content" style="top:30px" :style="{'bottom': emkt.leaveSpaceForFullScreen ? '5rem' : '3.5rem'}">
      <div class="buttons-tab" style="margin-top: 0.5rem">
        <a :href="'#tab'+(index+1)" v-for="(item, index) in asBillInfos" :class="'tab-link'+ (index===0?' active':'') +' button'">{{item.summary.settlementAccountName}}</a>
      </div>
      <div class="tabs">
        <div v-for="(item, index) in asBillInfos" :id="'tab'+(index+1)" :class="'tab'+(index===0? ' active' : '')">
          <div style="margin-top: 1rem;font-size: 14px;background-color: white;height: 70px;margin-left: 10px;margin-right: 10px" v-if="item.summary">
            <div class="jine" >
              <div>消费总金额</div>
              <div style="margin-top: 10px;color: #0f60c8;">{{item.summary.consumedMoneySum}}元</div>
            </div>
            <div class="jine">
              <div>已发货总金额</div>
              <div style="margin-top: 10px;color: #0f60c8;">{{item.summary.deliveryMoneySum}}元</div>
            </div>
            <div class="jine">
              <div>预付款余额</div>
              <div style="margin-top: 10px;color: #0f60c8;">{{item.summary.prepayAccountRestMoneySum}}元</div>
            </div>
          </div>
          <div style=" font-size: 16px;margin-top: 20px;margin-left: 10px" v-if="item.summary">
            发票信息
          </div>
          <div style="margin-top: .5rem;font-size: 14px;background-color: white;margin-left: 10px;margin-right: 10px" v-if="item.summary">
            <table class="account-item" style="width: 100%;">
              <tbody>
              <tr>
                <th>
                  已开票未回款金额
                </th>

                <th>
                  待开票总金额
                </th>
                <th>
                  已回款
                </th>
                <th>
                  押金
                </th>
              </tr>
              <tr>
                <td>
                  {{item.summary.openedNotReceivedInvoiceMoneySum}}元
                </td>
                <td>
                  {{item.summary.notOpenedInvoiceMoneySum}}元
                </td>
                <td>
                  {{item.summary.receivedMoneySum}}元
                </td>
                <td>
                  {{item.summary.depositMoneySum}}元
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div style=" font-size: 16px;margin-top: 20px;margin-left: 10px" v-if="item.invoiceList">
            明细（已开票未回款）
          </div>
          <div style="margin-top: .5rem;font-size: 14px;background-color: white;margin-left: 10px;margin-right: 10px">
            <table class="account-item" v-if="item.invoiceList" style="width: 100%;">
              <tbody>
              <tr>
                <th style="width: 28%">
                  发票编号
                </th>

                <th style="width: 33%">
                  金额
                </th>
                <th style="width: 33%;padding-right: 5px;">
                  发票开具日期
                </th>
              </tr>
              <tr v-for="invoice in item.invoiceList">
                <td class="idxn">
                  {{invoice.invoiceNo}}
                </td>
                <td>
                  {{invoice.invoiceMoney}}元
                </td>
                <td class="idxn">
                  {{invoice.invoiceBillingDT}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div style=" font-size: 16px;margin-top: 20px;margin-left: 10px;margin-bottom: 10px" v-if="item.consumeContractList">
            消费详情
          </div>
          <div class="list-block" v-if="item.consumeContractList" style="margin: 0rem">
            <contractInfoBox :contractInfo='contractInfo' :selected="selected" :type="type"></contractInfoBox>
            <div class="list-block media-list" v-if="timeList.length > 1" style="margin: 0rem">
              <div v-for="showdata in timeList" style="margin-left: 10px;margin-right: 10px">
                <ul  style="margin-bottom: 10px">
                  <li>
                    <a  class="item-link item-content">
                      <div class="item-inner" @click="showcontract(showdata)">
                        <div class="item-title" style="text-align: center">{{showdata.data}}年</div>
                      </div>
                    </a>
                  </li>
                </ul>
                <ul v-for="contract in item.consumeContractList" style="margin-bottom: 10px;font-size: .8rem" v-if="showdata.isshow && contract.contractStartDT.substring(0, 4) === showdata.data ">
                  <li class="item-content item-link">
                    <div class="item-inner">
                      <div  @click="showcontractInfo(contract)">
                        <div class="xfxq-i-1 clearfix">
                          <span class="fl sp1">{{contract.contractName}}</span>
                        </div>
                        <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                          <span class="fl">基因名称：-</span>
                          <span class="fr money">{{contract.contractMoney}}元</span>
                        </div>
                        <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                          <span class="fl">合同编号：{{contract.contractNo}}</span>
                          <span class="fr" style="margin-left: 20px">{{contract.contractSignDT}} </span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-else>
              <ul v-for="contract in item.consumeContractList" style="margin-left: 10px;margin-right: 10px;margin-bottom: 10px;font-size: .8rem">
                <li class="item-content item-link">
                  <div class="item-inner">
                    <div  @click="showcontractInfo(contract)">
                      <div class="xfxq-i-1 clearfix">
                        <span class="fl sp1">{{contract.contractName}}</span>
                      </div>
                      <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                        <span class="fl">基因名称：-</span>
                        <span class="fr money">{{contract.contractMoney}}元</span>
                      </div>
                      <div class="xfxq-i-1 clearfix"  style="font-size: .7rem">
                        <span class="fl">合同编号：{{contract.contractNo}}</span>
                        <span class="fr" style="margin-left: 20px">{{contract.contractSignDT}} </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
// import $ from 'jquery'
import {mapState, mapMutations} from 'vuex'
import contractInfoBox from './ContractInfoBox.vue'
import EMKT from '../../../emkt.js'
import FooterPlaceholder from '../../../views_v_2.6/components/FooterPlaceholder'

export default {
  mounted () {

  },
  components: {contractInfoBox, FooterPlaceholder},
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState([
      'sessionInfo', 'showContractInfoBox'
    ])
  },
  data () {
    return {
      sumdata: {},
      contractInfo: {},
      questionUrl: '/emktResources/resocurces/img/question.png',
      timeList: [],
      asBillInfos: [],
      selected: '个人',
      type: '消费明细',
      isWapp: EMKT.isWapp
    }
  },
  methods: {
    ...mapMutations(['SETCONTRCTINfFOBOX']),
    fetchData () {
      var _this = this
      // '00289663'
      _this.gcapi('loadCustomerBillInfo', _this.sessionInfo.customerInfo.customerNo
      ).then((response) => {
        console.log('response::', response)
        var data = {}
        data = JSON.parse(response.body.result)
        console.log(data)
        if (!data.result) {
          // $.toast(data.message)
        } else {
          _this.sumdata = JSON.parse(JSON.parse(response.body.result).json)
          _this.asBillInfos = _this.sumdata.asBillInfos
          for (const billInfoKey in _this.asBillInfos) {
            var list = _this.asBillInfos[billInfoKey].consumeContractList
            _this.timeList = []
            var newtimeList = []
            for (var i in list) {
              console.log(list[i].contractStartDT.substring(0, 4))
              if (newtimeList.indexOf(list[i].contractStartDT.substring(0, 4)) === -1) {
                newtimeList.push(list[i].contractStartDT.substring(0, 4))
                var showdata = {}
                showdata.isshow = false
                showdata.data = list[i].contractStartDT.substring(0, 4)
                _this.timeList.push(showdata)
              }
            }
            console.log('timeList:', _this.timeList)
            console.log('sumdata:', _this.sumdata)
            console.log('asBillInfos:', _this.asBillInfos)
          }
        }
      })
    },
    tolast () {
      this.$router.push({name: 'me'})
    },
    displayMessage (val) {
      if (!val) {
        return
      }
      let message
      message =
          '注:发票超期级别，异常为超过平均回款 周期，一级为超过2个，二级为超过1个。 正常是指还未超过平均回款周期。' +
          '您的历史平均回款周期：' + val.customerReceivePeriodAvg + '天' +
          '您单位历史平均回款周期：' + val.enterpriseReceivePeriodAvg + '天'
      this.$weui.alert(message)
      // $.alert(message)
    },
    showcontractInfo (contract) {
      this.contractInfo = contract
      console.log(this.showContractInfoBox)
      this.SETCONTRCTINfFOBOX(true)
    },
    senEmail () {
      var _this = this
      var customerNo = _this.sessionInfo.customerInfo.customerNo
      _this.gcapi('billInfoSendEmail', customerNo
      ).then((response) => {
        this.$weui.alert(response.body.result)
        // alert(response.body.result)
      })
    },
    submit () {
      var _this = this
      _this.gcapi('checkCustomerBillInfo', _this.sessionInfo.customerInfo.customerNo
      ).then((response) => {
        this.$weui.toast('感谢您对吉凯基因的支持!', 1500)
        // $.toast('感谢您对吉凯基因的支持!')
      })
    },
    showcontract (showdata) {
      if (showdata.isshow) {
        showdata.isshow = false
      } else {
        showdata.isshow = true
      }
    }
  }
}
</script>


<style scoped>
.item-inner {
  padding-bottom: 0rem
}
.jine {
  width: 33%;
  float:left;
  text-align: center;
  margin-top: 10px;
}
.jine1 {
  width: 25%;
  float:left;
  text-align: center;
  margin-top: 10px;
}
tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}
.account-item tr:first-child {
  color: #333333;
  font-size: 14px;
}
.account-item tr {
  height: 48px;
  border-bottom: 1px solid #e5e5e5;
  text-align: center;
}
.account-item tr th:nth-child(1) {
  width: 23%;
}
.account-item tr th {
  text-align: center;
}
.account h4 {
  color: #333333;
  font-size: 18px;
  margin-top: 37px;
}
.idxn {
  font-size: 12px;
  color: #585858;
}
.idxr {
  font-size: 12px;
  color: #e81b05;
  margin-left: 10px;
  cursor: pointer;
  position: relative;
}
.idxr span:before {
  content: '';
  width: 18px;
  height: 16px;
  display: inline-block;
  /*background: url(./../img/yichangguanli.png) no-repeat center;*/
}
.xfxq-i {
  padding: 15px;
  box-sizing: border-box;
  background-color: #fff;
  margin-bottom: 10px;
}
.item_watch {
  cursor: pointer;
}
.xfxq-i-1 .sp1 {
  font-size: 16px;
  color: #333;
  width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fl {
  float: left;
}
.clearfix:after {
  display: block;
  content: "";
  clear: both;
}
.xfxq-i-1 {
  padding: 3px 0;
  color: #666;
}
.fl {
  float: left;
}
.xfxq-i-1 .money {
  font-weight: 700;
}
.fr {
  float: right;
}
.continer{

  height:100px;

  width:100px;

  background-color: aqua;

}
fade{
  width:100%;
  height:100%;
  background:rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}
/*弹出层*/
.succ-pop{
  width: 400px;
  height: 300px;
  background: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -200px;
  margin-top: -150px;
  z-index: 999;
  border-radius: 5px;
}
.succ-pop h3.title{
  text-align: center;
  font-size: 22px;
  color: #ce002c;
}
.footer {
  position: fixed;
  left: 0;
  width: 100%;
  font-size: 14px;
  background-color: #e7e7e7;
  padding: 0px 10px;
}
</style>


// WEBPACK FOOTER //
// OldAccountChecked.vue?4e526783